__turbopack_context__.v({
  "findDestination": "DestinationsContent-module__e5lVba__findDestination",
  "findDestinationText": "DestinationsContent-module__e5lVba__findDestinationText",
  "otherDestinationsList": "DestinationsContent-module__e5lVba__otherDestinationsList",
  "section": "DestinationsContent-module__e5lVba__section",
  "sectionTitle": "DestinationsContent-module__e5lVba__sectionTitle",
  "tab": "DestinationsContent-module__e5lVba__tab",
  "tabContent": "DestinationsContent-module__e5lVba__tabContent",
  "tabContentForceMount": "DestinationsContent-module__e5lVba__tabContentForceMount",
  "tabListWrapper": "DestinationsContent-module__e5lVba__tabListWrapper",
  "topDestinationsList": "DestinationsContent-module__e5lVba__topDestinationsList",
  "topDestinationsListItem": "DestinationsContent-module__e5lVba__topDestinationsListItem",
});
